module.exports = __webpack_public_path__ + "media/hero-video.3499b305.mp4";